import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCoinsAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.25 10.3333C14.25 11.8675 11.7316 13.1111 8.625 13.1111C5.5184 13.1111 3 11.8675 3 10.3333M14.25 10.3333C14.25 8.79921 11.7316 7.55556 8.625 7.55556C5.5184 7.55556 3 8.79921 3 10.3333M14.25 10.3333V14.7778M3 10.3333V14.7778M21 4.77778C21 3.24365 18.4816 2 15.375 2C13.1485 2 11.2242 2.63881 10.3125 3.56552M21 4.77778C21 5.80595 19.8688 6.70365 18.1875 7.18394M21 4.77778V14.2222C21 15.0448 19.8688 15.7629 18.1875 16.1472M21 9.77778C21 10.6185 19.8181 11.3502 18.0749 11.7278M14.25 14.7778C14.25 16.3119 11.7316 17.5556 8.625 17.5556C5.5184 17.5556 3 16.3119 3 14.7778M14.25 14.7778V19.2222C14.25 20.7563 11.7316 22 8.625 22C5.5184 22 3 20.7563 3 19.2222V14.7778",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCoinsAlt;
